var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m467 91h-229.75l-34.528 415.796c6.068 3.034 12.594 5.204 19.763 5.204h244.515c24.814 0 45-20.186 45-45v-331c0-24.814-20.186-45-45-45z",
    fill: "#dae2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m169.867 407.86 7.969 64.721c1.6 12.854 10.3 26.922 24.886 34.215 29.167-31.374 9.614-11.341 78.829-85.796z",
    fill: "#4d97ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m281.551 421c4.907-5.608 9.211-9.373 8.053-17.095l-45.44-364.486c-2.798-22.471-22.002-39.419-44.648-39.419h-154.516c-24.814 0-45 20.186-45 45v331c0 24.814 20.186 45 45 45z",
    fill: "#4db5ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m165.707 118.056c-1.406-7.002-7.559-12.056-14.707-12.056h-30c-7.148 0-13.301 5.054-14.707 12.056l-30 150c-1.626 8.13 3.647 16.025 11.763 17.651 8.218 1.685 16.04-3.647 17.651-11.763l9.587-47.944h41.411l9.587 47.944c1.641 8.237 9.697 13.4 17.651 11.763 8.115-1.626 13.389-9.521 11.763-17.651zm-44.414 77.944 11.997-60h5.42l11.997 60z",
    fill: "#e6eeff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m436 226h-45v-15c0-8.291-6.709-15-15-15s-15 6.709-15 15v15h-45c-8.291 0-15 6.709-15 15s6.709 15 15 15h4.006c8.535 27.383 21.07 48.81 35.136 65.702-11.019 10.074-21.802 18.339-33.518 27.594-6.459 5.171-7.514 14.604-2.328 21.079 5.162 6.465 14.632 7.514 21.078 2.329 12.73-10.047 23.679-18.456 35.626-29.421 11.947 10.966 22.896 19.375 35.624 29.421 6.448 5.185 15.918 4.136 21.08-2.329 5.186-6.475 4.131-15.908-2.33-21.079-11.715-9.255-22.498-17.52-33.517-27.594 14.066-16.891 26.602-38.318 35.136-65.702h4.007c8.291 0 15-6.709 15-15s-6.709-15-15-15zm-60 73.467c-9.534-11.984-18.149-26.069-24.626-43.467h49.252c-6.477 17.399-15.092 31.483-24.626 43.467z",
    fill: "#53565c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslations);
export default __webpack_public_path__ + "static/media/translations.2f419bf65f2a8b8057a648b4f6350f82.svg";
export { ForwardRef as ReactComponent };